export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10174.066c9296.jpg";